export const LOGIN = 'PERSONAL_LOGIN/LOGIN';
export const LOGIN_SUCCESS = 'PERSONAL_LOGIN/LOGIN_SUCCESS';
export const LOGIN_ERROR = 'PERSONAL_LOGIN/LOGIN_ERROR';
export const SIGN_UP = 'PERSONAL_LOGIN/SIGN_UP';
export const SIGN_UP_SUCCESS = 'PERSONAL_LOGIN/SIGN_UP_SUCCESS';
export const SIGN_UP_ERROR = 'PERSONAL_LOGIN/SIGN_UP_ERROR';
export const RESTORE_PASSWORD = 'PERSONAL_LOGIN/RESTORE_PASSWORD';
export const RESTORE_PASSWORD_SUCCESS = 'PERSONAL_LOGIN/RESTORE_PASSWORD_SUCCESS';
export const RESTORE_PASSWORD_ERROR = 'PERSONAL_LOGIN/RESTORE_PASSWORD_ERROR';
export const SET_FIELD = 'PERSONAL_LOGIN/SET_FIELD';
export const SET_REDIRECT = 'PERSONAL_LOGIN/SET_REDIRECT';
export const SET_SIGN_UP = 'PERSONAL_LOGIN/SET_SIGN_UP';
export const SET_LOGGED_TYPE = 'PERSONAL_LOGIN/SET_LOGGED_TYPE';